const zh = {
  nav: {
    about: "关于我们",
    services: "服务内容",
    partners: "合作伙伴",
    contact: "联系我们",
    contactBtn: "联系我们",
  },
  hero: {
    tagline: "日本市场进入专家",
    title1: "共同开启",
    title2: "日本市场之门。",
    subtitle: "We open the door to Japan's market, together.",
    description: "最大化海外品牌潜力——日本首席总代理合作伙伴。",
    descriptionEn: "Maximizing the potential of overseas brands — Japan's premier general agency partner.",
    cta: "联系我们",
    ctaEn: "Contact Us",
    scroll: "滚动",
  },
  about: {
    label: "WHO WE ARE",
    labelJa: "关于我们",
    title: "Our Mission",
    titleEn: "Message from CEO",
    quote: "共同开启日本市场之门。",
    p1: "我们是连接优秀海外品牌与日本市场的专业团队。我们不仅仅是简单的进口代理商，而是作为战略合作伙伴，在保护品牌价值的同时，帮助品牌在日本市场扎根。",
    p2: "海外制造商在日本市场面临的挑战——语言障碍、复杂的法规、建立分销网络——这一切我们都全权负责。我们全力支持您的品牌在日本发光发热。",
    p3: "我们不是大企业——这正是我们的优势。我们与每一位客户认真对话，以速度和灵活性提供支持。充分发挥中小企业的机动性，为海外制造商进入日本市场提供细致而实践性的支援。",
    name: "山田 太郎",
    title2: "代表取締役 CEO",
    more: "了解更多",
    moreEn: "Learn More About Us",
    stat1: "20+",
    stat1Label: "覆盖国家",
    stat2: "100+",
    stat2Label: "合作企业",
    stat3: "15年",
    stat3Label: "丰富经验",
    stat4: "98%",
    stat4Label: "续约率",
  },
  services: {
    label: "OUR SERVICES",
    labelJa: "服务内容",
    title: "日本市场进入全流程，",
    title2: "一站式服务。",
    titleEn: "End-to-end support for your Japan market entry.",
    s1Title: "众筹业务",
    s1TitleEn: "Crowdfunding Business",
    s2Title: "电商业务",
    s2TitleEn: "E-Commerce Business",
    s3Title: "社交媒体营销・广告运营",
    s3TitleEn: "SNS Marketing & Advertising",
    s4Title: "法规与认证支持",
    s4TitleEn: "Regulatory & Compliance",
    s5Title: "客户支持",
    s5TitleEn: "Customer Support",
    viewAll: "查看服务详情",
    viewAllEn: "View All Services",
    backToHome: "返回首页",
    pageTitle: "我们的服务",
    pageTitle2: "详情",
    pageDescription: "从战略规划到执行落地，为海外品牌进入日本市场提供全方位支持。凭借20年以上的经验和专业知识，引领您的业务走向成功。",
    detail: {
      s1: {
        title: "众筹业务",
        titleEn: "Crowdfunding Business",
        desc: "我们利用Makuake、Campfire等日本主要众筹平台，帮助海外产品成功进入日本市场。从项目设计到运营和公关支持，提供一站式全程服务。",
        item1: "Makuake、Campfire等平台的出品战略制定与项目设计",
        item2: "日语文案撰写与视觉内容制作",
        item3: "众筹期间的社交媒体与公关运营",
        item4: "支持者沟通、回报发货及售后跟进管理",
      },
      s2: {
        title: "电商业务",
        titleEn: "E-Commerce Business",
        desc: "我们为海外品牌提供从店铺开设到日常运营的全面支持，覆盖亚马逊日本、乐天、Yahoo!购物等日本主要电商平台，助力销售最大化。",
        item1: "亚马逊、乐天、Yahoo!购物的店铺开设与搭建",
        item2: "商品页面优化（SEO、图片、文案）",
        item3: "库存管理、物流及FBA高效运营",
        item4: "广告运营（赞助广告、优惠券及促销策略）",
      },
      s3: {
        title: "社交媒体营销・广告运营",
        titleEn: "SNS Marketing & Advertising",
        desc: "充分发挥Instagram、TikTok、X（原Twitter）、YouTube等各平台特性，实施战略性营销与广告运营，提升品牌知名度并促进购买转化。",
        item1: "针对各平台特性的内容制作与发布运营",
        item2: "网红营销与联名企划",
        item3: "Meta广告、Google广告、TikTok广告的运营与优化",
        item4: "基于数据分析的PDCA循环与效果测量报告",
      },
      s4: {
        title: "法规与认证支持",
        titleEn: "Regulatory & Compliance",
        desc: "我们的专业团队为日本特有的复杂法规和认证提供全面支持。最小化风险，实现顺畅的市场进入。",
        item1: "药机法、食品卫生法、电波法等法规合规",
        item2: "JIS标准、SG标志等各种认证获取支持",
        item3: "进口手续和海关支持",
        item4: "产品标签和标识义务合规确认",
      },
      s5: {
        title: "客户支持",
        titleEn: "Customer Support",
        desc: "我们的专业支持团队以日语和英语处理终端用户咨询、投诉处理和售后服务。帮助提升品牌可信度，提高客户满意度。",
        item1: "日语和英语的多语言客户支持",
        item2: "咨询管理系统的构建与运营",
        item3: "投诉处理、退货和换货流程管理",
        item4: "客户满意度调查和反馈分析",
      },
    },
    ctaTitle: "从免费咨询开始",
    ctaDescription: "专业顾问将免费为您的品牌提供最适合的日本市场进入战略建议。",
    ctaButton: "申请免费咨询",
  },
  achievements: {
    label: "ACHIEVEMENTS",
    labelJa: "事业实绩",
    title: "事业实绩",
    titleEn: "Our Business Achievements",
    ec: {
      title: "国内电商业务",
      titleEn: "Domestic E-commerce Business",
      description: "通过运营自有电商网站和入驻大型电商平台，将国内外优质商品带给日本消费者。年销售额持续增长，建立了稳定的业务基础。",
    },
    web: {
      title: "网站构建与运营",
      titleEn: "Website Development & Operations",
      description: "为企业提供网站策划、设计、开发、运营的一站式服务。采用响应式设计、SEO优化、无障碍访问等最新技术和设计，增强客户的数字存在感。",
    },
  },
  partners: {
    label: "TRUSTED BY",
    labelJa: "合作实绩",
    title: "全球20+国家，",
    title2: "100+合作企业信赖。",
    titleEn: "Trusted by 100+ companies across 20+ countries.",
    note: "※ 展示部分合作伙伴",
    regions: {
      northAmerica: "北美",
      europe: "欧洲",
      asia: "亚洲",
      oceania: "大洋洲",
      middleEast: "中东",
    },
  },
  contact: {
    label: "CONTACT US",
    labelJa: "联系我们",
    title: "联系表单",
    titleEn: "Dedicated Inquiry Window for Overseas Manufacturers",
    englishAvailable: "支持英语 / English Available",
    companyName: "公司名称 / Company Name",
    yourName: "姓名 / Your Name",
    email: "电子邮件 / Email",
    phone: "电话号码 / Phone",
    country: "国家/地区 / Country",
    message: "咨询内容 / Message",
    messagePlaceholder: "请填写您的咨询内容。\nPlease describe your inquiry.",
    submit: "提交 / Submit",
    submitting: "发送中...",
    successTitle: "发送成功 / Message Sent",
    successMsg: "感谢您的咨询。我们的工作人员将在2个工作日内与您联系。\nThank you for your inquiry. Our team will contact you within 2 business days.",
    directContact: "直接联系",
    directContactEn: "Direct Contact",
    hours: "工作日 9:00 - 18:00 (JST)",
    address: "〒100-0001 东京都千代田区千代田1-1-1\n全球商务大厦 15F",
    required: "必填",
    selectCountry: "选择国家/地区",
    charLimit: "500字以内",
  },
  process: {
    label: "PROCESS / 合作流程",
    title: "合作流程",
    subtitle: "从首次咨询到销售启动，我们以速度和细心为您提供全程支持。",
    timelineLabel: "TIMELINE",
    timelineTitle: "标准步骤",
    faqLabel: "FAQ",
    faqTitle: "常见问题",
    ctaTitle: "欢迎随时咨询",
    ctaSubtitle: "如有任何关于产品或合作条件的问题，请随时联系我们。",
    ctaButton: "联系我们",
    navLink: "合作流程",
    steps: {
      s1Title: "咨询",
      s1TitleEn: "Inquiry",
      s1Desc: "请随时与我们联系。请告诉我们您的产品信息和销售目标。",
      s2Title: "市场分析・方案提案",
      s2TitleEn: "Analysis & Proposal",
      s2Desc: "我们分析您的产品在日本市场的潜力，提出最优销售策略，包括竞争调查和价格分析。",
      s3Title: "签约・启动销售",
      s3TitleEn: "Contract & Launch",
      s3Desc: "签约后立即开始销售准备，迅速推进众筹平台和电商平台的上架工作。",
      s4Title: "运营・支持",
      s4TitleEn: "Operation & Support",
      s4Desc: "销售启动后持续提供支持，包括库存管理、客户支持和营销执行，全程一站式服务。",
    },
    timeline: {
      t1: "咨询・初次会议",
      t2: "市场分析・销售策略制定",
      t3: "方案提案・签约",
      t4: "销售准备（页面制作・库存准备）",
      t5: "销售启动・运营支持",
    },
    faq: {
      q1: "合同期限是多久？",
      a1: "我们根据项目规模和内容灵活应对。仅众筹的短期合同也可以。",
      q2: "您们处理哪些类型的产品？",
      a2: "我们处理家电、数码产品、生活用品、服装等各类产品。请先随时咨询我们。",
      q3: "库存如何管理？",
      a3: "库存在日本国内仓库保管和管理，按订单发货。库存状况可实时查看。",
      q4: "开始销售需要多长时间？",
      a4: "签约后通常约2个月可以开始销售。众筹的情况下，准备期可能会缩短。",
    },
  },
  strengths: {
    s1: "年销售额超过3000万日元的销售业绩",
    s2: "3年以上的国内电商业务经验",
    s3: "在亚马逊、乐天、Yahoo!等平台的电商销售经验",
    s4: "大企业无法实现的快速决策",
    s5: "丰富的网站建设和广告收入业绩",
  },
  footer: {
    description: "最大化海外品牌潜力的日本首席总代理合作伙伴。凭借20年以上的经验和100家以上的合作企业，我们将您的品牌带入日本市场。",
    quickLinks: "快速链接",
    office: "办公室",
    legal: "法律信息",
    privacy: "隐私政策",
    terms: "使用条款",
    tokushoho: "特定商取引法表记",
    copyright: "© 2026 SHOP-MK. All Rights Reserved.",
  },
  legal: {
    backHome: "返回首页",
    lastUpdated: "最后更新",
  },
  aboutPage: {
    title: "公司简介",
    heroSub: "连接海外品牌与日本市场的战略合作伙伴。",
    missionLabel: "OUR MISSION",
    missionTitle: "将全球创新带到日本。",
    missionText1: "「想扩大事业，却没有余力开拓新市场。」",
    missionText2: "我们将日本市场带到您的业务中。",
    missionText3: "我们是您品牌在日本的总代理商，也是您的合作伙伴。销售、营销、物流、客户服务，全部交给我们。",
    missionText4: "首先通过众筹验证市场反应，获得市场认可后再全面进军电商平台。",
    missionText5: "您只需专注于产品本身。日本这个新市场，将成为您业务的一部分。",
    missionCta: "让我们一起，打造您品牌的下一个阶段。",
    bridgeTitle: "连接世界与日本的桥梁",
    bridgeText1: "我们是一家综合贸易公司，通过品牌代理、电商运营和广告管理业务，为海外制造商进入日本市场提供全方位支持。",
    bridgeText2: "公司名称「GlobalBridge」体现了我们与世界各地的合作伙伴共同成长的愿望。",
    bridgeText3: "利用我们从进口和销售美国产品中积累的经验和专业知识，为海外制造商进入日本市场提供全面支持。",
    strengthsLabel: "OUR STRENGTHS",
    strengthsTitle: "我们的优势",
    strengthSubtitle: "可靠的业绩和经验",
    businessLabel: "OUR BUSINESS",
    businessTitle: "三大业务",
    companyInfoTitle: "事业概要",
    info: {
      companyName: "事业所名称",
      companyNameValue: "SHOP-MK",
      established: "成立时间",
      establishedValue: "2025年1月",
      representative: "代表者姓名",
      representativeValue: "木佐 誠宏",
      repProfile: "代表者介绍",
      repText1: "大学毕业后，在国内企业担任系统工程师14年。积累了开发和构建经验，担任20个以上项目的项目经理。",
      repText2: "作为副业，成功将博客网站运营了3年，并在自由撰稿和视频剪辑方面实现了收益化。",
      repText3: "此后涉足亚马逊商品销售，主要在二手商品销售业务中取得了一定成果后独立创业。作为个人实现了约3000万日元的年销售额。",
      repText4: "目前作为海外制造商总代理，正在与各国制造商推进商谈。",
      revenue: "年销售额",
      revenueValue: "3000万日元（估算）",
    },
    ctaTitle: "欢迎随时咨询",
    ctaText: "如有任何关于合作或产品的问题，请随时与我们联系。",
    ctaButton: "联系我们",
  },
};

export default zh;
